/* eslint-disable linebreak-style */
import React from 'react';

const adaIcon = (fill: string, size: number, style?: React.CSSProperties) => (
    <svg
        id="Layer_2_1_"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size / 1.08181}
        viewBox="0 0 24 22.185"
    >
        <g id="Layer_1-2" transform="translate(0 0)" style={style}>
            <title>ada icon</title>
            <path
                id="Path_146"
                data-name="Path 146"
                d="M102.761,149.629a1.617,1.617,0,0,0,1.524,1.7h.1a1.616,1.616,0,1,0-1.62-1.7Z"
                transform="translate(-96.182 -138.617)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_147"
                data-name="Path 147"
                d="M.543,165.483a.523.523,0,1,0,.493.551.519.519,0,0,0-.493-.551Z"
                transform="translate(0.008 -154.887)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_148"
                data-name="Path 148"
                d="M90.1,10.929a.524.524,0,0,0-.474-.935.524.524,0,0,0,.474.935Z"
                transform="translate(-83.621 -9.302)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_149"
                data-name="Path 149"
                d="M109.737,47.8a.806.806,0,1,0-1.082-.359A.808.808,0,0,0,109.737,47.8Z"
                transform="translate(-101.621 -43.306)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_150"
                data-name="Path 150"
                d="M36.179,82.942a.666.666,0,1,0-.192-.922h0A.663.663,0,0,0,36.179,82.942Z"
                transform="translate(-33.579 -76.488)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_151"
                data-name="Path 151"
                d="M43.432,160.98a.808.808,0,1,0,.762.851h0A.808.808,0,0,0,43.432,160.98Z"
                transform="translate(-39.852 -150.672)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_152"
                data-name="Path 152"
                d="M36.648,244.654a.667.667,0,1,0,.9.295h0a.67.67,0,0,0-.9-.295Z"
                transform="translate(-33.959 -228.923)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_153"
                data-name="Path 153"
                d="M84.694,109.406a.948.948,0,1,0-.275-1.312.942.942,0,0,0,.275,1.312Z"
                transform="translate(-78.869 -100.769)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_154"
                data-name="Path 154"
                d="M241.136,47.422a.809.809,0,1,0-.23-1.12h0a.8.8,0,0,0,.23,1.12Z"
                transform="translate(-225.36 -42.997)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_155"
                data-name="Path 155"
                d="M268.862,10.516a.523.523,0,1,0-.154-.73.539.539,0,0,0,.154.73Z"
                transform="translate(-251.435 -8.94)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_156"
                data-name="Path 156"
                d="M223.463,147.861a1.616,1.616,0,1,0-.179,3.227h.09a1.615,1.615,0,0,0,.09-3.227Z"
                transform="translate(-207.566 -138.391)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_157"
                data-name="Path 157"
                d="M132.551,98.728a1.618,1.618,0,1,0,.717-2.177,1.62,1.62,0,0,0-.717,2.177Z"
                transform="translate(-123.905 -90.206)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_158"
                data-name="Path 158"
                d="M318.8,82.419a.666.666,0,1,0-.9-.294.677.677,0,0,0,.9.294Z"
                transform="translate(-297.487 -75.965)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_159"
                data-name="Path 159"
                d="M261.337,107.356a.949.949,0,1,0,1.274.423A.949.949,0,0,0,261.337,107.356Z"
                transform="translate(-244.122 -100.389)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_160"
                data-name="Path 160"
                d="M177.314,1.318a.675.675,0,0,0,.7-.627.667.667,0,0,0-1.332-.083.677.677,0,0,0,.627.711Z"
                transform="translate(-165.378 0.015)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_161"
                data-name="Path 161"
                d="M173.279,58.369a.949.949,0,1,0-.9-1,.943.943,0,0,0,.9,1Z"
                transform="translate(-161.35 -52.856)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_162"
                data-name="Path 162"
                d="M85.888,211.411a.949.949,0,1,0-1.274-.423A.949.949,0,0,0,85.888,211.411Z"
                transform="translate(-79.104 -196.193)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_163"
                data-name="Path 163"
                d="M192.146,97.13a1.616,1.616,0,1,0,1.351-.73A1.612,1.612,0,0,0,192.146,97.13Z"
                transform="translate(-179.603 -90.228)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_164"
                data-name="Path 164"
                d="M195.139,200.368a1.616,1.616,0,1,0-.717,2.17h0a1.609,1.609,0,0,0,.723-2.157C195.145,200.375,195.145,200.375,195.139,200.368Z"
                transform="translate(-179.785 -186.706)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_165"
                data-name="Path 165"
                d="M262.531,209.318a.948.948,0,1,0,.275,1.312.942.942,0,0,0-.275-1.312Z"
                transform="translate(-244.355 -195.771)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_166"
                data-name="Path 166"
                d="M308.793,161.232a.808.808,0,1,0-.851.762h0A.813.813,0,0,0,308.793,161.232Z"
                transform="translate(-287.521 -150.11)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_167"
                data-name="Path 167"
                d="M359.243,164.683a.523.523,0,1,0,.493.551A.527.527,0,0,0,359.243,164.683Z"
                transform="translate(-335.736 -154.138)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_168"
                data-name="Path 168"
                d="M319.35,244.128a.666.666,0,1,0,.192.922.663.663,0,0,0-.192-.922Z"
                transform="translate(-297.949 -228.397)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_169"
                data-name="Path 169"
                d="M90.762,320.639a.522.522,0,1,0,.147.723h0A.514.514,0,0,0,90.762,320.639Z"
                transform="translate(-84.196 -300.03)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_170"
                data-name="Path 170"
                d="M269.625,320.255a.524.524,0,0,0,.474.935.524.524,0,0,0-.474-.935Z"
                transform="translate(-252.102 -299.698)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_171"
                data-name="Path 171"
                d="M135.513,202.087a1.618,1.618,0,1,0-2.241.467,1.624,1.624,0,0,0,2.241-.467Z"
                transform="translate(-124.056 -186.804)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_172"
                data-name="Path 172"
                d="M110.191,275.471a.809.809,0,1,0,.23,1.12h0A.8.8,0,0,0,110.191,275.471Z"
                transform="translate(-101.967 -257.711)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_173"
                data-name="Path 173"
                d="M177.081,325.686a.667.667,0,1,0,.627.711.675.675,0,0,0-.627-.711Z"
                transform="translate(-165.087 -304.834)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_174"
                data-name="Path 174"
                d="M172.873,260.374a.949.949,0,1,0,.9,1,.943.943,0,0,0-.9-1Z"
                transform="translate(-160.873 -243.702)"
                fill={fill || '#0033AD'}
            />
            <path
                id="Path_175"
                data-name="Path 175"
                d="M241.746,275.114a.809.809,0,1,0,1.095.358.809.809,0,0,0-1.095-.358Z"
                transform="translate(-225.862 -257.418)"
                fill={fill || '#0033AD'}
            />
        </g>
    </svg>
);
export default adaIcon;
